import * as DOMPurify from 'dompurify'
import RadioGroup from '@mui/material/RadioGroup';
import { QuestionProps, QuestionType } from '../types'
import Answer from './Answer'
import styles from './Question.module.css'

export default function Question(props: QuestionProps) {
    const UpdateQuizTotal = (answer: string) => {
        props.OnUpdate(props.config.question_id, answer)
    }
    return (
        <div className={[styles.Question, (props.IsActive ? styles.QuestionShown : styles.QuestionHidden)].join(' ')}>
            <div className={styles.TheQuestion} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${props.config.question}`) }} />
            <div>
                {props.config.answers.map((answer, index) => {
                    const key = index
                    return (
                        <RadioGroup key={key}>
                            <Answer
                                ID={key.toString()}
                                checked={answer === props.Answer}
                                onChange={UpdateQuizTotal}
                                label={answer}
                                disabled={props.disabled}
                            />
                        </RadioGroup>
                    )
                })}
            </div>
        </div>
    )
}

export function ResetQuestion(question: QuestionType): QuestionType {
    return {
        ...question,
        input: '',
        follow_up_questions: question.follow_up_questions ? question.follow_up_questions.map(fq => ({
            ...fq,
            input: '',
        })) : [],
    }
}
